export enum WsEventType {
	// The subscription has been done and can be refreshed
	RefreshSubscription = 'RefreshSubscription',
}
